var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var mergeMenuWithPermissions = function (_a) {
    var menuItems = _a.menuItems, permissions = _a.permissions, _b = _a.defaultShown, defaultShown = _b === void 0 ? true : _b;
    return menuItems.reduce(function (acc, menuItem) {
        // todo refactor to more readability
        var isShown = defaultShown
            ? !menuItem.permission ||
                !(menuItem.permission in permissions) ||
                permissions[menuItem.permission]
            : !menuItem.permission || permissions[menuItem.permission];
        if (!isShown) {
            return acc;
        }
        if (menuItem.nextLevelItems) {
            var menuSectionResult = mergeMenuWithPermissions({
                menuItems: menuItem.nextLevelItems,
                permissions: permissions,
                defaultShown: defaultShown,
            });
            if (menuSectionResult.length) {
                acc.push(__assign(__assign({}, menuItem), { nextLevelItems: menuSectionResult }));
            }
            return acc;
        }
        acc.push(menuItem);
        return acc;
    }, []);
};
